<template>
    <tr>
        <td class="editor-content">
            <select class="form-control editor-form editor-select" v-model="spacing.side" @change="onSideChange">
                <option>none</option>
                <option>all</option>
                <option>top/bottom</option>
                <option>left/right</option>
                <option>left</option>
                <option>right</option>
                <option>top</option>
                <option>bottom</option>
            </select>
        </td>
        <td class="editor-content">
            <select class="form-control editor-form editor-select" v-model="spacing.value">
                <option>0</option>
                <option>1</option>
                <option>2</option>
                <option>3</option>
                <option>4</option>
                <option>5</option>
            </select>
        </td>
    </tr>
</template>

<script>
    export default {
        name: 'MarginSelector',
        props: ['spacing'],
        data () {
            return {
                model: webase.model
            }
        },
        methods: {
            onSideChange() {
                if(this.spacing.side === 'none') {
                    this.spacing.value = '0'
                }
            }
        }
    }
</script>
